module.exports = __webpack_public_path__ + "img/real.4e3aa971.webp";